import { t } from '@hefe/i18n';
import { AnalysisIssueAssignment } from '@hefe/models';
import { Tag } from 'antd';
import { roleLabels } from '../../utils/isue.utils';

interface IssueAssignmentTagProps {
  assignment: AnalysisIssueAssignment;
}

export default function IssueAssignmentTagComponent(
  props: IssueAssignmentTagProps
) {
  const { assignment } = props;

  return (
    <Tag color={assignment.blocking ? 'warning' : undefined}>
      {roleLabels[assignment.role]} | {assignment?.title ?? ''}
      {!assignment?.blocking &&
        ' ' + t('issues.blocking.' + (assignment.blocking ? 'yes' : 'no'))}
    </Tag>
  );
}
